<template>
  <InfuseModal
    :title="t('iam.users.create_machine_user.title')"
    @close="emit('close')"
    :disable-close="loading"
    optional-body-classes="lg:max-w-[515px]"
  >
    <form id="create-machine-user" @submit.prevent="onSubmit" class="flex flex-col gap-2">
      <InfuseField :label="t('iam.users.name')">
        <InfuseInput
          :required="true"
          v-model="nameMutation"
          :placeholder="t('iam.users.name_placeholder')"
        />
        <p class="mt-1 text-sm text-neutral-500">{{ t('iam.users.create_machine_user.name_helper') }}</p>
      </InfuseField>

      <InfuseField :label="t('iam.users.roles')">
        <RoleMultiSelect v-model="rolesMutation" :required="false" :level="navigationLevel" :parent-id="navigationParentId" />
      </InfuseField>
    </form>

    <template #actions>
      <InfuseButton
        data-testid="modal-cancel-button"
        color="secondary"
        type="button"
        @click="emit('close')"
        :disabled="loading"
      >
        {{ t('action.cancel') }}
      </InfuseButton>

      <InfuseButton
        data-testid="modal-confirm-button"
        type="submit"
        form="create-machine-user"
        :disabled="loading"
        :loading="loading"
      >
        {{ t('iam.users.create_machine_user.submit_button') }}
      </InfuseButton>
    </template>
  </InfuseModal>
</template>

<script setup lang="ts">
import { CreateMachineUser, UserLevel } from '@infuse/iam/user/type';
import { RoleMultiSelect } from '@infuse/iam/role/ui';
import { InfuseButton, InfuseField, InfuseInput, InfuseModal } from '@infuse/ui/components';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    loading?: boolean;
    navigationLevel?: UserLevel;
    navigationParentId?: string;
  }>(),
  {
    loading: false,
    navigationLevel: UserLevel.DOMAIN,
    navigationParentId: undefined
  }
);

interface Emits {
  (event: 'close'): void;
  (event: 'create', vars: { user: CreateMachineUser }): void;
}

const emit = defineEmits<Emits>();

const nameMutation = ref('');
const rolesMutation = ref<string[]>([]);

const onSubmit = () => {
  emit('create', { user: { name: nameMutation.value, roles: rolesMutation.value } });
};
</script>
